import React, { useContext, useEffect, useState } from "react";
import appConst from "../Utilities/appConst.json";
import { useSelector } from "react-redux";
import "../styles/footer.css";
import { LanguageContext } from "../context/language/LanguageContext";
import FooterDetialsItem from "../Components/FooterDetialsItem";

const FooterDetialsItems = (props) => {
  const languageContext = useContext(LanguageContext);
  const footer = useSelector((state) => state.footer.summary);
  const showPrices = useSelector((state) => state.footer.showPrices);

  const label = (key) => {
    return `${languageContext.getTranslation(key)}:`;
  };

  const [quantity, setQuantity] = useState();
  const [priceList, setPriceList] = useState();
  const [shipping, setShipping] = useState();
  const [quantityDiscount, setQuantityDiscount] = useState();
  const [additionalDiscount, setAdditionalDiscount] = useState();
  const [shippingDiscount, setShippingDiscount] = useState();

  const product = localStorage.getItem(appConst.PRODUCT); //appConst.ORDERS_UNION

  useEffect(() => {
    setQuantity(footer.quantity);
    setPriceList(footer.priceList);
    setQuantityDiscount(footer.tempQuantityDiscount || footer.quantityDiscount);
    setAdditionalDiscount(
      footer.tempAdditionalDiscount === 0
        ? 0
        : footer.tempAdditionalDiscount || footer.additionalDiscount
    );
    setShipping(
      footer.tempShipping === 0 ? 0 : footer.tempShipping || footer.shipping
    );
    setShippingDiscount(
      footer.tempShippingDiscount === 0
        ? 0
        : footer.tempShippingDiscount || footer.shippingDiscount
    );
  }, [footer]);

  return (
    <div className="summary_footer_with_details footer_container_top">
      {quantity != null && (
        <FooterDetialsItem
          testId={
            product !== appConst.ORDERS_UNION
              ? "footer-summary-total-items"
              : "footer-summary-total-orders"
          }
          text={
            product !== appConst.ORDERS_UNION
              ? label(appConst.TOTAL_ITEMS)
              : label(appConst.TOTAL_ORDERS)
          }
          numeric={quantity}
        />
      )}
      {showPrices && priceList != null && (
        <FooterDetialsItem
          testId="footer-summary-price-list"
          text={label(appConst.PRICE_LIST)}
          numeric={`₪${parseFloat(priceList).toFixed(2)}`}
        />
      )}
      {showPrices && quantityDiscount ? (
        <FooterDetialsItem
          testId="footer-summary-quantity-discount"
          text={label(appConst.QUANTITY_DISCOUNTS)}
          numeric={`₪(-${parseFloat(quantityDiscount).toFixed(2)})`}
        />
      ) : (
        <></>
      )}
      {showPrices && additionalDiscount ? (
        <FooterDetialsItem
          testId="footer-summary-additional-discount"
          text={label(appConst.ADDITIONAL_DISCOUNTS)}
          numeric={`₪(-${parseFloat(additionalDiscount).toFixed(2)})`}
        />
      ) : (
        <></>
      )}
      {shipping != null ? (
        <FooterDetialsItem
          testId="footer-summary-shipping"
          text={label(appConst.SHIPPING)}
          numeric={`₪${parseFloat(shipping).toFixed(2)}`}
        />
      ) : (
        <></>
      )}
      {shippingDiscount ? (
        <FooterDetialsItem
          testId="footer-summary-shipping-discount"
          text={label(appConst.SHIPPING_DISCOUNTS)}
          numeric={`₪(-${parseFloat(shippingDiscount).toFixed(2)})`}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default FooterDetialsItems;
